import { motion } from 'framer-motion';

const CLIT_X = 100;
const CLIT_Y = 70;
const ORBIT_R = 24;

// 8 keyframes tracing a full clockwise circle around the clitoris.
// Start at 3 o'clock so the entry into motion feels lateral, not vertical.
const orbitX = [
  CLIT_X + ORBIT_R,
  CLIT_X + ORBIT_R * 0.707,
  CLIT_X,
  CLIT_X - ORBIT_R * 0.707,
  CLIT_X - ORBIT_R,
  CLIT_X - ORBIT_R * 0.707,
  CLIT_X,
  CLIT_X + ORBIT_R * 0.707,
  CLIT_X + ORBIT_R,
];

const orbitY = [
  CLIT_Y,
  CLIT_Y - ORBIT_R * 0.707,
  CLIT_Y - ORBIT_R,
  CLIT_Y - ORBIT_R * 0.707,
  CLIT_Y,
  CLIT_Y + ORBIT_R * 0.707,
  CLIT_Y + ORBIT_R,
  CLIT_Y + ORBIT_R * 0.707,
  CLIT_Y,
];

export function OrbitIllustration() {
  return (
    <svg viewBox="0 0 200 200" className="absolute inset-0 h-full w-full">
      <defs>
        <radialGradient id="orbit-zone" cx="50%" cy="55%" r="45%">
          <stop offset="0%" stopColor="hsl(var(--primary))" stopOpacity="0.45" />
          <stop offset="100%" stopColor="hsl(var(--primary))" stopOpacity="0" />
        </radialGradient>
        <radialGradient id="orbit-clit-glow" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="hsl(var(--primary))" stopOpacity="0.9" />
          <stop offset="100%" stopColor="hsl(var(--primary))" stopOpacity="0" />
        </radialGradient>
        <filter id="orbit-glow" x="-100%" y="-100%" width="300%" height="300%">
          <feGaussianBlur stdDeviation="2.5" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>

      {/* Ambient zone glow */}
      <circle cx="100" cy="110" r="70" fill="url(#orbit-zone)" />

      {/* Outer almond / vulva form */}
      <path
        d="M 100 60 C 122 90, 122 138, 100 168 C 78 138, 78 90, 100 60 Z"
        fill="none"
        stroke="hsl(var(--secondary))"
        strokeWidth="1.6"
        strokeLinecap="round"
        opacity="0.7"
      />

      {/* Inner labia line, softer */}
      <path
        d="M 100 78 C 114 100, 114 130, 100 156 C 86 130, 86 100, 100 78 Z"
        fill="none"
        stroke="hsl(var(--secondary))"
        strokeWidth="1.1"
        strokeLinecap="round"
        opacity="0.4"
      />

      {/* Clitoral hood — a small arc cradling the focus point */}
      <path
        d="M 86 72 Q 100 60, 114 72"
        fill="none"
        stroke="hsl(var(--secondary))"
        strokeWidth="1.2"
        strokeLinecap="round"
        opacity="0.5"
      />

      {/* Clitoris focus — outer soft glow */}
      <circle cx={CLIT_X} cy={CLIT_Y} r="10" fill="url(#orbit-clit-glow)" />

      {/* Clitoris dot — the bright center, gentle pulse */}
      <motion.circle
        cx={CLIT_X}
        cy={CLIT_Y}
        r="3"
        fill="hsl(var(--primary))"
        filter="url(#orbit-glow)"
        animate={{ opacity: [0.75, 1, 0.75], scale: [1, 1.15, 1] }}
        style={{ transformOrigin: `${CLIT_X}px ${CLIT_Y}px` }}
        transition={{ duration: 2.6, repeat: Infinity, ease: 'easeInOut' }}
      />

      {/* Faint orbit trail — dashed ring as the path the fingertip traces */}
      <circle
        cx={CLIT_X}
        cy={CLIT_Y}
        r={ORBIT_R}
        fill="none"
        stroke="hsl(var(--accent))"
        strokeWidth="0.6"
        strokeDasharray="1 4"
        opacity="0.35"
      />

      {/* Fingertip orbiting the clitoris, never crossing it */}
      <motion.circle
        r="3.5"
        fill="hsl(var(--accent))"
        filter="url(#orbit-glow)"
        animate={{ cx: orbitX, cy: orbitY }}
        transition={{ duration: 6, repeat: Infinity, ease: 'linear' }}
      />
    </svg>
  );
}
